import { math } from 'polished'
import MaskedInput from 'react-text-mask'
import styled, { css } from 'styled-components'

export const Underline = styled.div`
  position: relative;
  top: -1px;
  width: 100%;
  height: 1px;
  background: ${p => p.theme.colors.blackOp07};

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 1px;
    background: ${p => p.theme.colors.black};
    transition-property: width;
    transition-duration: ${p => p.theme.animation.timeStandard};
    transition-timing-function: ease-in;
  }
`

const placeHolderAnimated = css`
  font-size: ${p => p.theme.typography.textSmallDescr};
  transform: translateY(
    -${p => math(`${p.theme.typography.textSmallDescr} * 2`)}
  );
  line-height: ${p => p.theme.typography.baseLh};
`

export const TextFieldPlaceholder = styled.span`
  position: absolute;
  top: 0;
  left: 1px;
  pointer-events: none;
  color: ${p => p.theme.colors.blackOp4};
  transition-property: font-size, transform;
  transition-duration: ${p => p.theme.animation.timeStandard};
  transition-timing-function: ${p => p.theme.animation.cubicBezier};
  line-height: ${p => p.theme.typography.baseLh * 1.26};

  & > b {
    display: none;
  }

  ${p => p.theme.mq.upMd} {
    & > b {
      display: inline;
      font-weight: 400;
      font-family: ${p => p.theme.typography.mediumFont};
    }
  }

  &:focus {
    ${placeHolderAnimated}
  }
`

export const TextFieldError = styled.span`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: ${p => p.theme.typography.inputErrorLh * 2}em;
  font-size: ${p => p.theme.typography.fontSizeS};
  line-height: ${p => p.theme.typography.inputErrorLh};
  overflow: hidden;
  color: ${p => p.theme.colors.materialRedOp6};
`

export const textFieldInputCss = css`
  display: block;
  width: 100%;
  outline: 0;
  border: none;
  padding: 0;
  background-color: transparent;
  height: ${p => p.theme.typography.baseLh * 1.26}em;
  line-height: ${p => p.theme.typography.baseLh * 1.26};
  color: inherit;

  &:focus {
    & ~ ${TextFieldPlaceholder} {
      ${placeHolderAnimated}
    }

    & ~ ${Underline}:after {
      width: 100%;
    }
  }
`

export const TextFieldInput = styled.input`
  ${textFieldInputCss}
`

export const MaskedInputStyled = styled(MaskedInput)`
  ${textFieldInputCss}
`

export const TextFieldWrapper = styled.label`
  display: block;
  position: relative;
  margin: ${p => p.theme.typography.textSmallDescr} 0 ${p =>
  p.theme.typography.inputErrorLh * 2}em;

  ${({ withoutError }) =>
    withoutError &&
    css`
      margin-bottom: 0;
    `}

  ${({ isWithDefaultValue }) =>
    isWithDefaultValue &&
    css`
      ${TextFieldPlaceholder} {
        ${placeHolderAnimated}
      }
    `}

  ${({ isWithMask }) =>
    isWithMask &&
    css`
      ${TextFieldPlaceholder} {
        ${placeHolderAnimated}
      }
    `}

  ${({ isError }) =>
    isError &&
    css`
      ${Underline} {
        background: ${p => p.theme.colors.materialRedOp6};

        &:after {
          background: ${p => p.theme.colors.materialRed};
        }
      }
    `}
`
